import React from "react";

const LockXIcon = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5183_3585)">
        <path
          d="M6.00098 8.50019V5.50032C6.00098 4.4395 6.42238 3.42212 7.17249 2.67201C7.92261 1.9219 8.93997 1.50049 10.0008 1.50049C11.0616 1.50049 12.079 1.9219 12.8291 2.67201C13.5792 3.42212 14.0006 4.4395 14.0006 5.50032V8.50019"
          stroke={color}
          stroke-linecap="round"
        />
        <path
          d="M3 9H16.9993V17.9996C16.9993 18.53 16.7886 19.0387 16.4136 19.4138C16.0385 19.7888 15.5299 19.9995 14.9994 19.9995H4.99991C4.4695 19.9995 3.96081 19.7888 3.58576 19.4138C3.2107 19.0387 3 18.53 3 17.9996V9Z"
          stroke={color}
          stroke-linejoin="round"
        />
        <path
          d="M12 13.0005L8 17.0005M8 13.0005L12 17.0005"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5183_3585">
          <rect
            width="20"
            height="20"
            fill={color}
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LockXIcon;
